import { Controller } from '@hotwired/stimulus'

// Verstuurt het formulier zodra een veld erin verandert — voor filterbalken
// waar een keuze meteen moet werken, zonder knop. Zet hem op het FORMULIER:
//
//   <form data-controller="auto-submit" data-action="change->auto-submit#submit">
//
// change-events bubbelen van de velden naar het formulier, dus één attribuut
// dekt alle velden erin. Bewust geen inline `onchange`: die blokkeert de
// productie-CSP (er staat een statische test op, csp_inline_handler_test).
export default class extends Controller {
  submit () {
    if (this.element.requestSubmit) this.element.requestSubmit()
    else this.element.submit()
  }
}
